export enum ClaimantDetailsEvents {
  AddClaimantDetailsClick = 'claimant_details_add_claimant_click',
  DownloadClaimantDetailsDataSheet = 'claimant_details_download_data_sheet',
  ClaimantDetailsBrowse = 'claimant_details_browse',
  ClaimantDetailsUploadSuccess = 'claimant_details_upload_success',
  ClaimantDetailsUplaodFailed = 'claimant_details_upload_failed',
  ClaimantDetailsSave = 'claimant_details_save',
}
